import React from 'react';
import { OphirButton } from '@/components/common/OphirButton';
import { Seo } from '@/components/common/Seo';

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | OPHIR SUPPLY" description="The page you are looking for could not be found." />
      <section className="bg-ophir-ivory-soft">
        <div className="container-ophir py-28 text-center">
          <p className="font-serif text-[64px] text-ophir-navy">404</p>
          <h1 className="mt-2 font-serif text-[28px] text-ophir-navy-deep">Page not found</h1>
          <p className="mt-3 text-ophir-muted">The page you are looking for could not be found.</p>
          <div className="mt-8"><OphirButton to="/">Return Home</OphirButton></div>
        </div>
      </section>
    </>
  );
}
